function SectionFaqJobs() {
    return (
        <>
            <div className="tw-faq-section">
                <div className="accordion tw-faq" id="sf-faq-accordion-2">
                    {/*one*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ1-2" aria-expanded="false">
                            How do I redeem a coupon?
                        </button>
                        <div id="FAQ1-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                Coupon codes can be entered on the checkout summary page when choosing a plan. Once validated, the promotional discount will apply automatically to your final purchase bill.
                            </div>
                        </div>
                    </div>
                    {/*two*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ2-2" aria-expanded="false">
                            How long will it take to post my job?
                        </button>
                        <div id="FAQ2-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                Submitting a job listing takes less than five minutes. Your job will enter draft status immediately and becomes visible to candidates following our brief verification process.
                            </div>
                        </div>
                    </div>
                    {/*three*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ3-2" aria-expanded="false">
                            What is your cancellation policy?
                        </button>
                        <div id="FAQ3-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                You can cancel any job subscription plans or close active advertisements directly under your account settings. There are no cancellation penalties or hidden fees.
                            </div>
                        </div>
                    </div>
                    {/*four*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ4-2" aria-expanded="false">
                            Where Can I Find Market Research Reports?
                        </button>
                        <div id="FAQ4-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                Market insight files, trending industry demands, and hiring guide sheets are compiled and updated monthly inside our resources section in the employer dashboard.
                            </div>
                        </div>
                    </div>
                    {/*five*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ5-2" aria-expanded="false">
                            Do I need to know PHP to use TheJobs?
                        </button>
                        <div id="FAQ5-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                Not at all! The platform handles all technical infrastructure. You only need to type in your job requirements and manage incoming applicants from our UI.
                            </div>
                        </div>
                    </div>
                    {/*six*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ6-2" aria-expanded="false">
                            How soon will I start receiving resumes?
                        </button>
                        <div id="FAQ6-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                You will start receiving notification alerts and candidate profiles as soon as the first jobseeker clicks the apply button on your published jobs.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SectionFaqJobs;